import { render, staticRenderFns } from "./HomepageFrequentSteps.vue?vue&type=template&id=52042ec4&scoped=true"
import script from "./HomepageFrequentSteps.vue?vue&type=script&lang=js"
export * from "./HomepageFrequentSteps.vue?vue&type=script&lang=js"
import style0 from "./HomepageFrequentSteps.vue?vue&type=style&index=0&id=52042ec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52042ec4",
  null
  
)

export default component.exports